exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-6[data-v-64e95b8d] {\n  width: 6%;\n}\n.darken[data-v-64e95b8d]:hover {\n background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(0, 0, 0, 0.1)));\n background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0 0);\n}\n.btn-outline-primary[data-v-64e95b8d]:hover {\n  color: #135075 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64e95b8d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/webapp/patient/external/MenttumProxyView.vue
// module id = 4029
// module chunks = 78